// eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins
// tslint:disable
/**
 * This file is generated. Do not edit manually
 */
"use strict";
import * as $protobuf from "protobufjs/light";
var $root = $protobuf.roots.protoGeneric || ($protobuf.roots.protoGeneric = new $protobuf.Root());
$root.addJSON({
    Request: {
        fields: {
            commandId: {
                type: "int32",
                id: 1,
            },
            sequenceNumber: {
                type: "int32",
                id: 2,
            },
            data: {
                type: "bytes",
                id: 3,
            },
        },
    },
    Response: {
        fields: {
            commandId: {
                type: "int32",
                id: 1,
            },
            sequenceNumber: {
                type: "int32",
                id: 2,
            },
            statusCode: {
                type: "int32",
                id: 3,
            },
            data: {
                type: "bytes",
                id: 4,
            },
        },
    },
});
export var protoGeneric = $root;



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/generated/protoGeneric.ts
// module id = 2990
// module chunks = 3